import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import TextoMulta from './TextoMulta'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import InlineLoader from '../../../../../components/InlineLoader/InlineLoader'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { useGlobal } from '../../../../../contexts/GlobalContext'
import { useSolicitacaoCancelamento } from '../../../../../contexts/SolicitacaoCancelamentoContext'
import { BOTAO_SEGUIR_CANCELAMENTO } from '../constantsCancelarAssinatura'
import { BOTAO_PERMANECER } from '../ArgumentosProduto/constantsArgumentosProduto'
import { EVENTOS_GA, ROUTE_BASEPATH, URLS, MODALIDADE_CURADORIA, MODALIDADE_INEDITOS } from '../../../../../constants'
import { enviaEventoGA } from '../../../../../utils/helpers/helpersGA'
import { useModalidade } from '../../../../../contexts/ModalidadeContext'
import { navigate } from '@reach/router'
import { URLS_APP } from '../../../../../config'

const BotoesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: 50px 0 0;
  width: 100%;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 0;
    justify-content: flex-end;
  }

  button {
    &:first-of-type {
      margin-right: 15px;
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 16px;
      margin: 0;

      &:first-of-type {
        margin-right: 0;
        margin-bottom: 5px;
      }
    }
  }
`
const LoadingWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100%;
  width: 100%;
`

const AvisoMulta = ( { onClickPermanecer } ) => {
  const { modalidadeURL, dadosGlobaisAssociado } = useGlobal()
  const { getQuantidadeKitsMulta, numeroKitsMulta } = useSolicitacaoCancelamento()
  const {
    listaPlanosPorModalidade,
    fetchPlanos,
    assinaturaPorModalidade
  } = useModalidade()
  const [ valorMulta, setValorMulta ] = useState( null )

  const handleContinuarSolicitacao = () => {
    navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeURL}/${
      URLS.PLANO
    }/${URLS.CANCELAR_ASSINATURA_SUSPENSAO}` )
  }

  useEffect( () => {
    const { 'slug': curadoriaSlug, 'visualizacao': curadoriaVisualizacao } = MODALIDADE_CURADORIA
    const { 'visualizacao': ineditosVisualizacao } = MODALIDADE_INEDITOS
    const sanitizedCategory = modalidadeURL === curadoriaSlug ? curadoriaVisualizacao : ineditosVisualizacao
    const dadosAssinatura = dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura.modalidade === sanitizedCategory )

    getQuantidadeKitsMulta( dadosAssinatura.id )
    fetchPlanos( modalidadeURL )
  }, [] )

  useEffect( () => {
    if ( listaPlanosPorModalidade ) {
      const valorCaixa = assinaturaPorModalidade?.valorLiquido / 12
      setValorMulta( valorCaixa * numeroKitsMulta )
    }
  }, [ listaPlanosPorModalidade, numeroKitsMulta ] )

  return (
    <Card
      className="card"
      largura="100%"
    >
      {( valorMulta || valorMulta === 0 ) ? (
        <>
          <TextoMulta
            category={ modalidadeURL }
            quantidadeKitsMulta={ numeroKitsMulta }
            valorMulta={ valorMulta }
          />

          <BotoesWrapper>
            <Button
              invertido
              onClick={ () => {
                enviaEventoGA(
                  EVENTOS_GA.CANCELAMENTO.FLUXO,
                  EVENTOS_GA.CANCELAMENTO.ACOES
                    .SEGUIR_CANCELAMENTO_SUSPENSAO_TELA_MULTA
                )
                handleContinuarSolicitacao()
              } }
              tema={ Button.BOTAO_CURADORIA }
              testId="seguir-cancelamento2"
            >
              {BOTAO_SEGUIR_CANCELAMENTO}
            </Button>

            <Button
              onClick={ () => {
                enviaEventoGA(
                  EVENTOS_GA.CANCELAMENTO.FLUXO,
                  EVENTOS_GA.CANCELAMENTO.ACOES.PERMANECER_TELA_MULTA
                )
                onClickPermanecer()
              } }
              tema={ Button.BOTAO_CURADORIA }
              type={ Button.TYPE_SUBMIT }
            >
              {BOTAO_PERMANECER}
            </Button>
          </BotoesWrapper>
        </>
      ) : (
        <LoadingWrapper>
          <InlineLoader />
        </LoadingWrapper>
      )}
    </Card>
  )
}

AvisoMulta.propTypes = {
  'onClickPermanecer': PropTypes.func.isRequired
}

export default AvisoMulta
